module.exports = __webpack_public_path__ + "img/QR.09de0c8f.jpg";